import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FuseConfigService } from '@fuse/services/config';

@Component({
    selector: 'ashcorp-background',
    templateUrl: './background.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
})
export class AshcorpBackgroundComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    watermark_path: string = 'https://api.ashcorp.xyz/assets/watermark.php';

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _cdr: ChangeDetectorRef
    ) {
    }

    /**
     * On init
     */
    ngOnInit(): void {
        this._fuseConfigService.config$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (config) => {
                    this.watermark_path = config.watermark || this.watermark_path;
                    this._cdr.detectChanges();
                }
            );
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
